import React, {Component} from 'react';
import imagesPath from '../config/imagesPath';


class Homeslider extends Component {

    render() {

        return (
            <div className="homeslider">

                <div>
                    <div className="homeorder_1 ">
                        <img src={imagesPath.destopView} alt='' className="homeboys d-none d-md-block d-lg-block"/>
                        <img src={imagesPath.mobileView} alt='' className="homeboys homeboy_1 center d-block d-md-none"
                             style={{
                                 bottom: '20px'
                             }}/>
                    </div>
                </div>
            </div>
        )
    }
}


export default Homeslider



// WEBPACK FOOTER //
// ./src/components/homeslider.js